import { render, staticRenderFns } from "./registration-agreement.vue?vue&type=template&id=5626caf2&scoped=true&"
import script from "./registration-agreement.vue?vue&type=script&lang=js&"
export * from "./registration-agreement.vue?vue&type=script&lang=js&"
import style0 from "./registration-agreement.vue?vue&type=style&index=0&id=5626caf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626caf2",
  null
  
)

export default component.exports